import React, { useRef, useState } from 'react';
import { Box, Input } from '@chakra-ui/react';
import TypeaheadDropDown from './TypeaheadDropDown';
import useClickOutside from '../../../hooks/useClickOutside';
const Typeahead = ({ onSelectResult, searchResults, onChange, placeholder, onBlur, variant, width, name, id, isDisabled, isFetching, isFetched, }) => {
    const [value, setValue] = useState('');
    const [resultsHidden, setResultsHidden] = useState(true);
    const wrapperRef = useRef(null);
    useClickOutside(wrapperRef, () => setResultsHidden(true));
    const onSelect = (result) => {
        setValue('');
        setResultsHidden(true);
        onSelectResult(result);
    };
    const onLocalChange = (event) => {
        setValue(event.target.value);
        setResultsHidden(false);
        if (onChange) {
            onChange(event);
        }
    };
    return (React.createElement(Box, { "data-testid": "typeahead_wrapper", ref: wrapperRef },
        React.createElement(Input, { type: "text", id: id, value: value, name: name, onChange: onLocalChange, onBlur: onBlur, placeholder: placeholder, variant: variant, width: width, disabled: isDisabled }),
        React.createElement(TypeaheadDropDown, { isHidden: resultsHidden, results: searchResults, showLoadingSpinner: isFetching, showNoResultsMessage: !!isFetched && (!searchResults || searchResults?.length === 0), onClick: onSelect })));
};
export default Typeahead;
